import { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { IconButton, Stack, Typography } from "@mui/material";

import { TableLayout } from "../../layout/TableLayout";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { numberFormat } from "../../../helpers/numberFormat";
import { deleteReservation } from "../../helpers/reservation";
import { EditReservation } from "../reservation/EditReservation";
import { selectReservation } from "../../../store/reservation/reservationSlice";

export const ViewOpportuniteReservationTable = ({
  rows,
  setReloadData,
  vehiclesList,
}) => {
  const { t } = useTranslation("global");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const startup = searchParams.get("name");
  const dispatch = useDispatch();
  const [openEdit, setOpenEdit] = useState(false);

  const onEditClick = (e) => {
    dispatch(selectReservation(e.row));
    setOpenEdit(true);
    setReloadData((prevState) => !prevState);
  };

  const onDeleteClick = async (e) => {
    await deleteReservation(
      e,
      t("reservation.successMsgDelete"),
      t("delete.errorMsg"),
      t("delete.cancelButton"),
      t("delete.confirmButton"),
      t("reservation.delete")
    );
    setReloadData((prevState) => !prevState);
  };

  const columns = [
    {
      field: "idCrm",
      headerName: "ID CRM",
      minWidth: 100,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "club",
      headerName: "Club",
      minWidth: 100,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "isInApp",
      headerName: t("reservation.originOfReserve"),
      minWidth: 100,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "whoInvests",
      headerName: t("reservation.whoInvests"),
      minWidth: 220,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "intention",
      headerName: t("reservation.intentionView"),
      minWidth: 160,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <Typography color="primary" variant="body2">
            {row?.intention === "Reserva realizada"
              ? t("opportunities.Reserva realizada")
              : row?.intention === "No reserva"
              ? t("opportunities.No reserva")
              : t("opportunities.noanswer")}
          </Typography>
        );
      },
    },
    {
      field: "amount",
      headerName: t("reservation.amount"),
      minWidth: 150,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Typography color="primary" variant="body2">
            {numberFormat(params.row.amount)}
          </Typography>
        );
      },
    },
    {
      field: "action",
      headerName: t("partnerlist.columnActions"),
      maxWidth: 130,
      align: "center",
      headerAlign: "center",
      flex: 0,
      sortable: false,
      renderCell: (params) => {
        return (
          <Stack direction="row" gap={0}>
            <IconButton color="secondary" onClick={() => onEditClick(params)}>
              <EditRoundedIcon />
            </IconButton>

            <IconButton color="secondary" onClick={() => onDeleteClick(params)}>
              <DeleteOutlineRoundedIcon />
            </IconButton>
          </Stack>
        );
      },
    },
  ];

  return (
    <>
      <TableLayout
        rows={rows.map((reservation) => {

          return {...reservation, isInApp: reservation.isInApp ? "App" : "Extranet"}
        })}
        columns={columns}
        title="opportunitiesReservation"
        name={startup}
      />
      {openEdit && (
        <EditReservation
          setHidden={setOpenEdit}
          setReloadData={setReloadData}
          vehiclesList={vehiclesList}
        />
      )}
    </>
  );
};
